import adminRoles from "./constants/adminRoles.json";

function normalizeRoles(roles) {
  if (!roles) return [];

  if (Array.isArray(roles)) {
    return roles.flatMap((role) => {
      if (typeof role === "string") return [role];
      if (role && typeof role === "object") {
        if (Array.isArray(role.roles)) return role.roles;
        if (typeof role.role === "string") return [role.role];
      }
      return [];
    });
  }

  if (typeof roles === "string") {
    return [roles];
  }

  if (typeof roles === "object") {
    if (Array.isArray(roles.roles)) return roles.roles;
    if (typeof roles.role === "string") return [roles.role];
  }

  return [];
}

export function isAdminRole(roles) {
  const normalizedRoles = normalizeRoles(roles);
  return normalizedRoles.some((role) => adminRoles.includes(role));
}